var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "119.39px",
    height: "133.038px",
    viewBox: "0 0 119.39 133.038",
    enableBackground: "new 0 0 119.39 133.038",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#C9C6C3",
    points: "2,41.221 2,35.844 27.937,30.782 115.872,82.974 115.872,86.77 71.905,130.42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E8E5DC",
    points: "54.507,2 2,35.844 71.905,126.624 115.872,82.974  "
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#9B9D9D",
    cx: 90.409,
    cy: 95.627,
    rx: 5.22,
    ry: 5.376
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#54B3E5",
    points: "54.191,9.273 10.54,37.425 63.047,106.696 102.27,71.903  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.32d2ff0d2e42c99748fab7b9b3c715d9.svg";
export { ForwardRef as ReactComponent };